<template>
  <div class="app2">
    <div class="head">
      <div class="navLunbo">
        <li v-for="(item, index) in NavList" :key="index" :class="{ active: index == current }" @click="change(index)">
          <p>{{ item }}</p>
          <div :class="{ xiahuaxian: index == current }"></div>
        </li>
      </div>
      <div class="icon">
        <div class="sousuoIcon" @click="goSearch">
          <img src="../assets/images/search.png" alt="" />
        </div>
        <div class="fabuIcon" @click="show = true">
          <img src="../assets/images/fabu.png" alt="" />
        </div>
      </div>
      <van-overlay :show="show" @click="show = false">
        <div class="wrapper">
          <div class="fabuList">
            <div class="suishou" @click="goFabu">
              <img src="../assets/images/fabuCamera.png" alt="" />
              <div class="word">随手拍</div>
            </div>
            <div class="suishou" @click="goMypic">
              <img src="../assets/images/fabuOwn.png" alt="" />
              <div class="word">我的</div>
            </div>
          </div>
        </div>
      </van-overlay>
    </div>

    <div class="container2">
      <Hudong4 v-if="current == 0"></Hudong4>
      <Hudong2 v-else-if="current == 1"></Hudong2>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import { Swipe, SwipeItem } from "vant";
import { Tabbar, TabbarItem } from "vant";
import { Tab, Tabs } from "vant";
import { Popup } from "vant";
import { Overlay } from "vant";
import { Dialog } from "vant";
Vue.use(Overlay);

Vue.use(Popup);

Vue.use(Tab);
Vue.use(Tabs);

Vue.use(Tabbar);
Vue.use(TabbarItem);

Vue.use(Swipe);
Vue.use(SwipeItem);
import { doRem } from "../utils/setrem";
import Hudong2 from "../components/Hudong2";
import Hudong4 from "../components/Hudong4";

export default {
  components: {
    Hudong2,
    Hudong4,
  },

  created() {
    console.log("created");
    doRem();
  },

  mounted() {
    document.querySelector("body").setAttribute("style", "overflow:hidden;");
  },
  destroyed() {
    document.querySelector("body").setAttribute("style", "overflow:auto; ");
  },
  data() {
    return {
      NavList: ["交通出行", "失物招领"],
      current: 0,
      FabuPopup: false,
      show: false,
      loading: false,
      img: "../assets/images/noAddr.png",
    };
  },
  methods: {

    change(index) {
      this.current = index;
    },
    showFabuPopup() {
      this.FabuPopup = true;
    },
    goSearch() {
      this.$router.push("HudongSearch");
    },
    goFabu() {
      this.$router.push("Fabu");
    },
    goMypic() {
      this.$router.push("/myzone");
    },
    getHeight() {
      let a = window.screen.availHeight;

      let b =
        document.querySelector(".container2").offsetTop -
        document.documentElement.scrollTop;

      document.querySelector(".container2").style.height = a - b + "px";
    },
    getToken() {
      let token = this.$route.query.token;
      localStorage.setItem("token", token);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/Hudong.scss";
</style>
<style lang="scss" scoped>
.head ::v-deep .van-overlay .wrapper {
  width: 18.5rem;
  height: 16.125rem;
  position: fixed;
  top: 6rem;
  right: 0.75rem;
  padding: 3.75rem 4.625rem 3.375rem 3.25rem;

  background-image: url("../assets/images/suishoubg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: 0 0;

  .fabuList {
    width: 100%;
    height: 100%;
    white-space: nowrap;
    flex-direction: column;
    display: flex;
    justify-content: space-between;

    .suishou {
      display: flex;
      // justify-content: space-between;
      align-items: center;

      img {
        width: 3rem;
        height: 3rem;
      }

      .word {
        font-size: 1.875rem;
        color: #555555;
        margin-left: 2.25rem;
      }
    }
  }
}
</style>
